module.exports = __webpack_public_path__ + "img/EducationalScheduleTimeDetails.6d27f4b1.svg";